import { GlobalController } from 'src/shared/global/GlobalController'
import AnalyzeInvoiceSettlement from './AnalyzeInvoiceSettlement.vue'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export const routes = [
  {
    path: ':link',
    name: 'analyze-invoice-settlement',
    component: AnalyzeInvoiceSettlement,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
